import axios from "axios";
export default axios.create({
  baseURL: "http://159.89.46.247:4000",
  responseType: 'json',
});